"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomEmbed = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
function CustomEmbed(_a) {
    var { className, embedHTML, ratio = '16:9' } = _a, props = __rest(_a, ["className", "embedHTML", "ratio"]);
    const generateRatioPadding = (ratioString) => {
        const [ratioWidth, ratioHeight] = ratioString.split(':');
        return `${(parseInt(ratioHeight) / parseInt(ratioWidth)) * 100}%`;
    };
    return (react_1.default.createElement("div", Object.assign({ className: (0, classnames_1.default)('w-full h-auto relative', className), style: {
            paddingBottom: generateRatioPadding(ratio),
            height: 'min-content',
        } }, props),
        react_1.default.createElement("div", { className: "custom-embed", style: {
                objectFit: 'cover',
                width: '100%',
                height: '100%',
                position: 'absolute',
                top: 0,
                left: 0,
            } },
            react_1.default.createElement("div", { className: "embed-responsive", dangerouslySetInnerHTML: { __html: embedHTML } }))));
}
exports.CustomEmbed = CustomEmbed;
